import type { ReactElement, ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

import { cn } from '@repo/lib-design-system/utils/tw-merge.util';

import koalaLogo from '@/assets/logo/koala-logo.svg';

interface HeaderProps {
  logo?: string | null;
  nav?: ReactNode;
}

function Header({ logo, nav }: HeaderProps): ReactElement {
  return (
    <header className="sticky top-0 z-30 flex items-center justify-between bg-background px-8 py-6">
      <Link aria-label="Koala" to="/">
        <img
          alt="Koala"
          className={cn('h-8 w-auto', !logo && 'dark:invert')}
          src={logo ?? koalaLogo}
        />
      </Link>
      {nav}
    </header>
  );
}

export default Header;
